/**
 *
 * @author: Matthew Rawson @ 22/08/2018 13:32
 * @description:
 * @notes:
 */
import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import id from "@irati/utils/id"
import Icon from "@irati/ui/src/Icon"
import {FormattedMessage} from "@irati/utils/lang"

import {Para} from "../../../ui/Labels"
import {IconTooltip} from "../../../ui/Tooltip"

const Wrapper = styled.div`
  display: none;
  justify-content: space-between;
  align-items: center;

  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    display: inline-flex;
  `}

  > * {
    margin-right: 6px;
    :last-child {
      margin-right: 0;
    }
  }
`


const CoreQuestionHeader = ({className, tooltip, ...props}) => {
  const idNamespace = id("CoreQuestionHeader", props)

  return (
    <Wrapper id={idNamespace} className={className}>
      <Icon id={id("iconPadlock", idNamespace)} icon="padlock" size={16} />
      <Para flush><FormattedMessage id="insights.global.labels.coreQuestions" /></Para>
      {tooltip && <IconTooltip id={idNamespace} placement="top">{tooltip}</IconTooltip>}
    </Wrapper>
  )
}


CoreQuestionHeader.propTypes = {
  className: PropTypes.string,
  tooltip: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ])
}
CoreQuestionHeader.defaultProps = {
  className: null,
  tooltip: null
}

export default CoreQuestionHeader
